// extracted by mini-css-extract-plugin
module.exports = {"visibilityHolder":"StepsToBecomeAvailableAlert_visibilityHolder__2giAu"};